module.exports = __webpack_public_path__ + "static/assets/7505eb91025feedf35fef871e3518c28.png";